<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月23日 14:40:53
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>

    <div class="filter-container">
      <el-drawer
      class="drawer"
      direction="ltr"
      size="71%"
      :visible.sync="swtich"
      :before-close="handleClose"
      :with-header="false">
        <div class="filter" v-loading.fullscreen.lock="filterscreenLoading">
          <div class="close-swtich" @click="openFilter(false)">
            <span class="title">收缩</span>
            <el-image
                class="left-image"
                slot="prefix"
                :src="nvaLeft"
              fit="contain"></el-image>
          </div>
          <el-menu
              class="el-menu-vertical-demo"
              background-color="#fff"
              text-color="#000">
              <template v-if="filterType==1||filterType==2">
                <el-submenu index="1">
                  <template slot="title">
                    <span class="title">楼栋</span>
                  </template>
                  <el-menu-item  index="1-1">
                    <el-checkbox-group @change="localUpdateFilter({arr:$event,type:0})" v-model="activeBuildings" >
                      <el-checkbox-button v-for="building in buildingAreas" :label="building.Name" :key="building.Name">{{building.Name}}</el-checkbox-button>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="2">
                  <template slot="title">
                    <span class="title">楼层</span>
                  </template>
                  <el-menu-item  index="2-1">
                    <el-checkbox-group @change="localUpdateFilter({arr:$event,type:1})" v-model="activeFloors" >
                      <template  v-for="building in buildingAreas">
                        <template v-for="floor in building.Floors">
                          <el-checkbox-button v-if="activeBuildings.length==0||activeBuildings.indexOf(building.Name)!=-1" :key="floor.Name" :label="building.Name+'||'+floor.Name">{{floor.Name}}</el-checkbox-button>
                        </template>
                      </template>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="3">
                  <template slot="title">
                    <span class="title">房间</span>
                  </template>
                  <el-menu-item  index="3-1">
                    <el-checkbox-group @change="localUpdateFilter({arr:$event,type:2})" v-model="activeRomms" >
                      <template  v-for="building in buildingAreas">
                        <template v-if="activeBuildings.length==0||activeBuildings.indexOf(building.Name)!=-1">
                          <template  v-for="floor in building.Floors">
                            <template v-if="activeFloors.length==0||activeFloors.indexOf(building.Name+'||'+floor.Name)!=-1">
                              <el-checkbox-button v-for="room in floor.Rooms" :key="room" :label="building.Name+'||'+floor.Name+'||'+room">
                                {{room}}
                              </el-checkbox-button>
                            </template>
                          </template>
                        </template>
                      </template>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
              </template>

              <template v-if="filterType==1||filterType==3">
                <el-submenu index="4">
                  <template slot="title">
                    <span class="title">项目大类</span>
                  </template>
                  <el-menu-item  index="4-1">
                    <el-checkbox-group @change="localUpdateFilter({arr:$event,type:3})" v-model="activeCategorys">
                      <el-checkbox-button v-for="(item,index) in projectCategories" :label="item.Name" :key="index">{{item.Name}}</el-checkbox-button>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="5">
                  <template slot="title">
                    <span class="title">项目明细</span>
                  </template>
                  <el-menu-item  index="5-1">
                    <el-checkbox-group @change="localUpdateFilter({arr:$event,type:4})" v-model="activeDetails">
                      <template  v-for="categorys in projectCategories">
                        <template v-for="details in categorys.Items">
                          <el-checkbox-button v-if="activeCategorys.length==0||activeCategorys.indexOf(categorys.Name)!=-1" :key="categorys.Name+'||'+details.Name" :label="categorys.Name+'||'+details.Name">{{details.Name}}</el-checkbox-button>
                        </template>
                      </template>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="6">
                  <template slot="title">
                    <span class="title">班次</span>
                  </template>
                  <el-menu-item  index="6-1">
                    <el-checkbox-group v-model="activeShifts" @change="localUpdateFilter({arr:$event,type:5})">
                      <el-checkbox-button v-for="shift in shifts" :label="shift" :key="shift">{{shift}}</el-checkbox-button>
                    </el-checkbox-group>
                  </el-menu-item>
                </el-submenu>
              </template>
            </el-menu>
        </div>
      </el-drawer>
    </div>
    
</template>

<script>
import { mapState,mapGetters,mapMutations,mapActions } from 'vuex'
import nvaLeft from '@/assets/imgs/left@2x (2).png'
export default {
  // 组件参数 接收来自父组件的数据
  props: {
      swtich:Boolean
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
   return {
     nvaLeft,
     //选中楼区 楼层 房间
    activeBuildings: [],
    activeFloors:[],
    activeRomms:[],
    activeCategorys:[],
    activeDetails:[],
    activeShifts:[],
    //筛选类型 1全部2楼栋-房间3护理-班次
    filterType:2
   }
  },
  // 计算属性
  computed: {
    //筛选开关
    ...mapState('filter', ['filterscreenLoading','shifts','buildingAreas','buildings','floors','rooms','projectCategories','categorys','details']),
    ...mapState('filter', {
      filterActiveShifts: 'activeShifts',
    }),
    //用户信息
    //用户信息
    ...mapGetters(['user']),
    selectRooms(){
      let level=this.activeRomms.length?3:this.activeFloors.length?2:this.activeBuildings.length?1:0;
      let rooms=[]
      switch (level) {
        case 3:
          rooms=this.activeRomms.map(item=>item.split('||')[2])
          break;
        case 2:
          this.activeFloors.map(item=>{
            item=item.split('||')[1]
            rooms=rooms.concat(this.floors[item])
          })
          break;
        case 1:
          this.activeBuildings.map(item=>{
            rooms=rooms.concat(this.buildings[item])
          })
          break;
        default:
          // rooms=this.rooms
          break;
      }
      return rooms
    },
    selectDetails(){
      let level=this.activeDetails.length?2:this.activeCategorys.length?1:0;
      let details=[]
      switch (level) {
        case 2:
          details=this.activeDetails.map(item=>item.split('||')[1])
          break;
        case 1:
          this.activeCategorys.map(item=>{
            details=details.concat(this.categorys[item])
          })
          break;
        default:
          // details=this.details
          break;
      }
      return details
    }
  },
  // 侦听器
  watch: {
    $route: {
      handler: function(val){
        this.openFilter(false)
        switch (val.name) {
          case 'nursingOne':
            this.filterType=2
            break;
          case 'nursingOneImplement':
            this.filterType=3
            break;
          default:
            this.filterType=1
            break;
        }
      },
      immediate:true
    },
    
    selectRooms(arr){
      this.updateSelectVal({arr,type:0})
    },
    selectDetails(arr){
      this.updateSelectVal({arr,type:1})
    },
    activeShifts(arr){
      this.updateSelectVal({arr,type:2})
    },
    filterActiveShifts:{
      handler:function(val){
        if(val!=this.activeShifts){
          this.activeShifts=val
        }
      },
      immediate: true
    }

  },
  // 组件方法
  methods: {
    localUpdateFilter({type,arr}){
      switch (type) {
          case 0:
            this.activeFloors=this.activeFloors.filter(floor=>{
              return arr.indexOf(floor.split('||')[0])!=-1
            })
            this.activeRomms=this.activeRomms.filter(room=>{
              return arr.indexOf(room.split('||')[0])!=-1
            })
              break;
          case 1:
            this.activeRomms=this.activeRomms.filter(room=>{
              return arr.filter(item=>{
                return item.split('||')[1]==room.split('||')[1]
              }).length>0
            })
              break;
          case 3:
            this.activeDetails=this.activeDetails.filter(detail=>{
              return arr.indexOf(detail.split('||')[0])!=-1
            })
              break;
          default:
              break;
      }
      
    },


    ...mapMutations('filter', ['updateSelectVal']),
    ...mapActions('filter', ['openFilter']),
    //关闭滑屉
    handleClose() {
      this.openFilter(false)
    },
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
  },
  /**
  * 在挂载开始之前被调用：相关的 render 函数首次被调用。
  */
  beforeMount () {
  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {
    
  },
  /**
  * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  */
  beforeUpdate () {
  },
  /**
  * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  */
  updated () {
  },
  /**
  * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
  */
  activated () {
  },
  /**
  * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
  */
  deactivated () {
  },
  /**
  * 实例销毁之前调用。在这一步，实例仍然完全可用。
  */
  beforeDestroy () {
  },
  /**
  * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
  * 所有的事件监听器会被移除，所有的子实例也会被销毁。
  */
  destroyed () {
  }
}
</script> 

<style scoped>
.drawer{
  top: 44px;
  height: calc(100vh - 44px);
}

.filter{
  width: 266px;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
}
.filter >>> .el-menu-item{
  padding: 0px !important;
}
.filter >>> .el-checkbox-group{
  display: flex;
  flex-flow: wrap;
}
.filter >>> .el-checkbox-button{
  width: 73px;
}
.filter >>> .el-checkbox-button{
  margin: 10px 6px 10px 0px;
}

.filter >>> .el-checkbox-button__inner{
  width: 100%;
  border-radius: 2px !important;
    padding: 6px 10px;
  border: 1px solid #C7C9CC;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #434649;
}
.filter >>> .el-submenu__title{
  padding: 0px !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.filter >>> .el-menu-item{
  background-color: rgba(0, 0, 0, 0) !important;
}

.filter >>> .el-submenu .el-menu-item,.filter >>> .el-menu-item,.filter >>> .el-submenu__title{
  height: auto ;
}


.filter >>> .is-checked .el-checkbox-button__inner{
  background: #029FD1 !important;
  color: #fff !important;
}
/* .filter >>> .is-focus .el-checkbox-button__inner:hover{
  
} */


.close-swtich{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  margin:0px 10px 10px 0px; 
}
.left-image{
  width: 16px;
  height: 16px;
  margin-left: 3px;
}
.v-enter-active,.v-leave-active {
  transition: all .3s ease;
}
.v-enter-to{
  margin-left: 0px;
}
.v-enter,.v-leave-to{
  margin-left: -115px;
}

.el-menu{
  border-right: none;
}
.title{
  font-size: 16px;
  color: #0A0E10;
  font-weight: 500;
  font-family: 'PingFang SC Medium';
}
</style>



// WEBPACK FOOTER //
// src/common/left-filter.vue